import {
  ConfirmationState,
  ExactNameSearch,
  PersonensucheModal,
  SearchlistItem,
} from '@ps20-frontend/frontend-models';

export interface SearchDialogContainerState<T extends SearchlistItem> {
  searchString?: string;
  open: boolean;
  loading: boolean;
  confirmation: ConfirmationState;
  error: boolean;
  errorMessage: string;
  items: T[];
  selectedItem: T;
  confirmed: boolean;
  renderedColumns: string[];
  exactNameSearchString?: ExactNameSearch;
  personensucheModal: PersonensucheModal;
  angebotsId?: string;
}

export const CHANGE_SEARCH_DIALOG_STATE = 'CHANGE_SEARCH_DIALOG_STATE';

export interface SearchDialogContainerStateChangeAction<T extends SearchlistItem> {
  type: 'CHANGE_SEARCH_DIALOG_STATE';
  payload: Partial<SearchDialogContainerState<T>>;
}

export function isSearchDialogReducerAction<T extends SearchlistItem>(
  value: unknown,
): value is SearchDialogContainerStateChangeAction<T> {
  return (value as SearchDialogContainerStateChangeAction<T>).type === CHANGE_SEARCH_DIALOG_STATE;
}

export const searchDialogReducer = <T extends SearchlistItem>(
  sectionState: SearchDialogContainerState<T>,
  action: SearchDialogContainerStateChangeAction<T>,
): SearchDialogContainerState<T> => {
  if (action.type === CHANGE_SEARCH_DIALOG_STATE) {
    return {
      ...sectionState,
      ...action.payload,
    };
  }
  return sectionState;
};

export const changeSearchDialogState = <T extends SearchlistItem>(
  values: Partial<SearchDialogContainerState<T>>,
): SearchDialogContainerStateChangeAction<T> => ({
  type: CHANGE_SEARCH_DIALOG_STATE,
  payload: values,
});
